module.exports = __webpack_public_path__ + "r-v3/img/emoti-wink.d82a6d85.svg";